import { api } from "../api/client.js";

// Port of src/user/modules/info_elements/terms-api.ts. Acceptance is per (user, version): bumping
// CURRENT_TERMS.version in termsContent.js leaves no acceptance row, so everyone is re-prompted.

export async function hasAcceptedTerms(version) {
  const data = await api.get("/ui/terms/acceptance", { params: { version } });
  return data?.accepted === true;
}

export function acceptTerms(version) {
  return api.post("/ui/terms/accept", { version });
}
